<div id="register-form-wrapper" fusePerfectScrollbar >
    <div id="register-form" class="p-32">
        <app-estabelecimento-lista></app-estabelecimento-lista>
    </div>
</div>